
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[locale]",
      function () {
        return require("private-next-pages/[region]/[locale]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[locale]"])
      });
    }
  